<template>
  <div class="user-form">
    <toolbar
      backRoute="/dashboard/my-profile"
      title="Deactivate 2FA" />

    <d-container fluid class="common-form px-0 pt-5 pb-5 text-center">
      <d-form>
        <validation-observer ref="deactivate-2fa-form" tag="form">
          <d-row>
            <d-col cols="4" class="ml-auto mr-auto">
              <div class="form-group">
                <p>Provide a valid 2FA code below to deactivate 2FA on your account.</p>
              </div>

              <div class="form-group">
                <label for="name">Code:</label>

                <validation-provider
                  rules="required"
                  name="code"
                  v-slot="{ errors }">
                  <d-input
                    v-model="data.code"
                    type="number"
                    :length="6"
                    size="lg"
                    class="w-50 ml-auto mr-auto"
                    :state="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group d-flex mt-5 text-center">
                <d-button
                  outline
                  theme="danger"
                  class="ml-auto mr-auto"
                  @click.prevent="validateForm">
                  Deactivate 2FA
                </d-button>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-container>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'deactivate-2fa-form',
  data () {
    return {
      data: {
        code: ''
      }
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['deactivate-2fa-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = '/2fa/disable';

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: {
          code: this.data.code
        },
        successTitle: '2FA has been deactivated',
        successText: 'Your account is now NOT protected with 2FA',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          this.$router.push('/dashboard/my-profile');
          this.$root.loadProfile();
        },
        failAction: () => {
          this.data.code = '';
        }
      });
    }
  }
}
</script>
